/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  ForbiddenResponse,
  GetDiscrepancyTotalResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get current total discrepancy for a branch
 */
export const getDiscrepancyTotal = (signal?: AbortSignal) => {
  return customInstance<GetDiscrepancyTotalResponseResponse>({
    url: `/bm-declaration-service/v1/discrepancy/total`,
    method: 'get',
    signal,
  });
};

export const getGetDiscrepancyTotalQueryKey = () => {
  return [`/bm-declaration-service/v1/discrepancy/total`] as const;
};

export const getGetDiscrepancyTotalQueryOptions = <
  TData = Awaited<ReturnType<typeof getDiscrepancyTotal>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscrepancyTotal>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDiscrepancyTotalQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDiscrepancyTotal>>> = ({ signal }) =>
    getDiscrepancyTotal(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDiscrepancyTotal>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDiscrepancyTotalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDiscrepancyTotal>>
>;
export type GetDiscrepancyTotalQueryError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Get current total discrepancy for a branch
 */
export const useGetDiscrepancyTotal = <
  TData = Awaited<ReturnType<typeof getDiscrepancyTotal>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscrepancyTotal>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDiscrepancyTotalQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
